export const getBundleAwareItemCount = (items) => {
  if (!items || !Array.isArray(items)) {
    return 0;
  }

  return items.reduce((total, item) => {
    if (item.type === 'Collateral') {
      return total;
    }

    if (
      item.type === 'Bundle' &&
      item.bundleItems &&
      Array.isArray(item.bundleItems)
    ) {
      const bundleChildItemsTotal = item.bundleItems.reduce(
        (bundleTotal, bundleItem) => {
          if (bundleItem.type === 'Collateral') {
            return bundleTotal;
          }
          return bundleTotal + (bundleItem.quantity || 1);
        },
        0
      );
      const bundleChildCount = bundleChildItemsTotal * item.quantity;
      return total + bundleChildCount;
    } else {
      return total + item.quantity;
    }
  }, 0);
};
